module.exports = __webpack_public_path__ + "static/media/Kaduna.182f1713.png";